import * as React from "react";
import { MenuItem, Select } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { URLS } from "../../services/urls.ts";

export default function UserPopover({ userEmail }: { userEmail: string }) {
  const { logout } = useAuth0();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const navigate = useNavigate();
  const open = Boolean(anchorEl);

  return (
    <>
      <Select
        style={{ color: "white", height: "60px", border: "none" }}
        value="email"
      >
        <MenuItem
          style={{ display: "none" }}
          onClick={() => navigate(URLS.profile())}
          key="account"
          value={"email"}
        >
          {userEmail}
        </MenuItem>
        <MenuItem
          onClick={() => navigate(URLS.profile())}
          key="account"
          value={"account"}
        >
          Account Settings
        </MenuItem>
        <MenuItem onClick={() => logout()} value="logout">
          Logout
        </MenuItem>
      </Select>
    </>
  );
}
